import { observeClassChangeOn } from "../utils";

const playVideoCover = () => {
    let video = document.querySelector("video#host-video-cover");
    if (video) {
        observeClassChangeOn(video, () => {
            if (video.classList.contains("twic-poster-done") && video.classList.contains("twic-done")) {
                video.play();
            }
        });
    }
};

export default playVideoCover;
